<button type="button" class="btn-add-category" [hidden]="showAutoComplete" (click)="showInput()">
  @if (!selectedCategory) {
    <span>
      <craft-icon class="svg-icon text-size-11 mr-4" name="general--plus-sm"></craft-icon>
      Choose category
    </span>
  } @else {
    <span class="selected ellipsis">
      <span class="ellipsis">{{ selectedCategory.name }}</span>
      <craft-icon class="svg-icon text-size-11" name="arrows--arrow-head-down-sm"></craft-icon>
    </span>
  }
</button>

@if (showAutoComplete) {
  @if (categories$ | async; as categories) {
    <input
      #searchInput
      craftAutoFocus=""
      [focusDelay]="100"
      [matAutocomplete]="auto"
      [formControl]="searchControl"
      (keydown.enter)="onEnterKey($event, categories)"
      type="text"
      aria-label="Number"
      placeholder="Search or add new"
    />

    <mat-autocomplete
      #auto="matAutocomplete"
      [displayWith]="displayFn"
      (optionSelected)="selectCategory($event.option.value)"
      (closed)="menuClosed()"
      class="categories-autocomplete"
    >
      @if (searchInput.value && categories.length === 0) {
        <mat-option class="category-option" [value]="{ name: searchInput.value }">
          <b>Create new:</b> {{ searchInput.value }}
        </mat-option>
      }

      @for (category of categories | slice: 0 : 100; track category.id || category.name) {
        <mat-option class="category-option" [value]="category" [matTooltip]="category.name">
          {{ category.name }}
        </mat-option>
      }
    </mat-autocomplete>
  }
}
